import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal, Input ,FormGroup,} from "reactstrap";
import {
  GET_DT_KEYIN_MAJOR_LOSS,
  GET_DT_KEYIN_MINOR_LOSS,
  GET_DT_KEYIN_PLAN_MONTH,
  SAVE_DT_KEYIN_MAJOR_LOSS,
  SAVE_DT_KEYIN_MINOR_LOSS,
  SAVE_DT_KEYIN_PLAN_MONTH,
} from "helpers/url_api_constant";
import React, { useEffect, useState, useMemo } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import debounce from "lodash.debounce";
import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import { getPermission } from "../../../../helpers/auth_helper";
import Select from "react-select";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

const formatNumber = (cellContent, row) => {
  // console.log(cellContent);
  return (
    <div>
      {numberFormat(cellContent, 2)}
    </div>
  );
};

const columnColor = [
  "rgb(126 142 218)",
  "rgb(100 120 215)",
  "rgb(85 110 230)",
  "rgb(67 98 248)",
];


export default function GasDelivery(props) {
  const generateYearList = () => {
    const currentYear = new Date().getFullYear();
    let years = [];
    for (let index = currentYear - 4; index <= currentYear; index++) {
      years.push({ label: index, value: index });
    }
    return years;
  };
  const currentYear = new Date().getFullYear();
  const [listYear, setListYear] = useState(generateYearList());
  // DropDown Search
  const [yearSelected, setYearSelected] = useState({
    label: currentYear,
    value: currentYear,
  });
  const handleSelectedYear = selected => {
    setYearSelected(selected);
  };
  const permission = getPermission();
  const dispatch = useDispatch();
  const [listDataGasDeliveryPlan, setListDataGasDeliveryPlan] = useState([]);
  const [listDataLossMajor, setListDataLossMajor] = useState([]);
  const [listDataLossMinor, setListDataLossMinor] = useState([]);
  const addHeaderTableGasDeliveryPlan = () => {
    let thead = document
      .getElementById("gas-delivery-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '</th><th colspan="5" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Gas Delivery Plan</th>';
    thead.prepend(tr);
  };

  const addHeaderTableLossMajor = () => {
    let thead = document
      .getElementById("loss-major-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '</th><th colspan="3" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Gas Loss (รายใหญ่)</th>';
    thead.prepend(tr);
  };
  const addHeaderTableLossMinor = () => {
    let thead = document
      .getElementById("loss-minor-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '</th><th colspan="3" style="text-align:center;background-color:#6478D7;color:#FFFFFF">Gas Loss (รายย่อย)</th>';
    thead.prepend(tr);
  };
  useEffect(() => {
    addHeaderTableGasDeliveryPlan();
    // addHeaderTableLossMajor();
    // addHeaderTableLossMinor();
  }, []);
  useEffect(() => {
    fetchData();
  }, [yearSelected.value]);
  const generateRow = () => {
    function getDaysInMonth(year) {
      // console.log(year)
      let monthListGasDeliveryPlanModel = [];
      // let monthListGasLossMajor = [];
      // let monthListGasLossMinor = [];
      for (let index = 0; index < 12; index++) {
        let date = new Date(year, index, 1);

        monthListGasDeliveryPlanModel.push({
          ...gasDeliveryPlanModel,
          PLAN_DATE: moment(date).format("YYYY-MM-DD"),
          PLAN_MONTH: moment(date).format("M"),
          month: moment(date).format("M"),
        });
        // monthListGasLossMajor.push({
        //   ...lossMajorModel,
        //   MAJORLOSS_DATE: moment(date).format("YYYY-MM-DD"),
        //   MAJORLOSS_MONTH: moment(date).format("M"),
        //   month: moment(date).format("M"),
        // });
        // monthListGasLossMinor.push({
        //   ...lossMinorModel,
        //   MINORLOSS_DATE: moment(date).format("YYYY-MM-DD"),
        //   MINORLOSS_MONTH: moment(date).format("M"),
        //   month: moment(date).format("M"),
        // });
      }

      return [
        monthListGasDeliveryPlanModel,
        // monthListGasLossMajor,
        // monthListGasLossMinor,
      ];
    }

    let month;

    month = getDaysInMonth(yearSelected.value);
    // props.yearSelected
    return month;
    // setModelDeviceList(dayList);
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = "bold";
    style.color = "#FFFFFF";
    // style.border = "2px solid #FFFFFF";
    // style.opacity = "0.6";

    return style;
  };

  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      let [listPlan] = generateRow();
      // let [listPlan, ListLossMajor, ListLossMinor] = generateRow();
      // console.log(listPlan,ListLossMajor,ListLossMinor)
      let res = await post(GET_DT_KEYIN_PLAN_MONTH, {
        // props.yearSelected
        PLAN_YEAR: moment(new Date(yearSelected.value, 0, 1)).format(
          "YYYY-MM-DD"
        ),
      });
      // let [res1, res2, res3] = await Promise.all([
      //   post(GET_DT_KEYIN_PLAN_MONTH, {
      //     PLAN_YEAR: moment(new Date(props.yearSelected, 0, 1)).format(
      //       "YYYY-MM-DD"
      //     ),
      //   }),
      //   post(GET_DT_KEYIN_MAJOR_LOSS, {
      //     MAJORLOSS_YEAR: moment(new Date(props.yearSelected, 0, 1)).format(
      //       "YYYY-MM-DD"
      //     ),
      //   }),
      //   post(GET_DT_KEYIN_MINOR_LOSS, {
      //     MINORLOSS_YEAR: moment(new Date(props.yearSelected, 0, 1)).format(
      //       "YYYY-MM-DD"
      //     ),
      //   }),
      // ]);

      setListDataGasDeliveryPlan(listPlan.map(row => {
        let planData = res.data.dtKeyinPlanMonthList.find(obj => moment(obj.PLAN_DATE).format("YYYY-MM-DD") == row.PLAN_DATE && obj.PLAN_MONTH == row.PLAN_MONTH)
        return { ...row, ...planData }
      }));
      // setListDataLossMajor(ListLossMajor.map(row => {
      //   let majorData = res2.data.dtKeyinMajorLossList.find(obj => moment(obj.MAJORLOSS_DATE).format("YYYY-MM-DD") == row.MAJORLOSS_DATE && obj.MAJORLOSS_MONTH == row.MAJORLOSS_MONTH)
      //   return { ...row, ...majorData }
      // }));
      // setListDataLossMinor(ListLossMinor.map(row => {
      //   let minorData = res3.data.dtKeyinMinorLossList.find(obj => moment(obj.MINORLOSS_DATE).format("YYYY-MM-DD") == row.MINORLOSS_DATE && obj.MINORLOSS_MONTH == row.MINORLOSS_MONTH)
      //   return { ...row, ...minorData }
      // }));
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [...listDataGasDeliveryPlan];

      let res = await post(SAVE_DT_KEYIN_PLAN_MONTH, data);
      // let [res1, res2, res3] = await Promise.all([
      //   post(SAVE_DT_KEYIN_PLAN_MONTH, listDataGasDeliveryPlan),
      //   post(SAVE_DT_KEYIN_MAJOR_LOSS, listDataLossMajor),
      //   post(SAVE_DT_KEYIN_MINOR_LOSS, listDataLossMinor),
      // ]);
      if (res.resultCode != 200) {
        dispatch(messageAction.showMessage(res.resultDescription));
        // } else if (res2.resultCode != 200) {
        //   dispatch(messageAction.showMessage(res2.resultDescription));
        // } else if (res3.resultCode != 200) {
        //   dispatch(messageAction.showMessage(res3.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const InputRemark = (cellContent, row) => {
    return (
      // <AvForm className="needs-validation">
      <div>
        <Input
          type="textarea"
          // name="PLAN_REMARK"
          // errorMessage="Enter Description"
          style={{color:"#FFFFFF"}}
          className="form-control"
          disabled={permission.eOTH != true}
          onChange={e => {
            // console.log(e.target.value);
            setListDataGasDeliveryPlan(prevData => {
              return prevData.map(item => {
                // console.log(item);
                if (item.PID === row.PID) {
                  // console.log(e.target.value);
                  return { ...item, PLAN_REMARK: e.target.value};
                }
                return { ...item };
              });
            })
            // setRemark(e.target.value, row)
          }
          }
          value={row.PLAN_REMARK}
        />

      </div>
      // </AvForm>
    );
  };

  // const setRemark = useMemo(
  //   () =>
  //     debounce((value, row) => {
  //       console.log(value, row);
  //       setListDataGasDeliveryPlan(prevData => {
  //         return prevData.map(item => {
  //           // console.log(item);
  //           if (item.PID === row.PID) {
  //             // console.log(e.target.value);
  //             return { ...item, PLAN_REMARK: value};
  //           }
  //           return { ...item };
  //         });
  //       })
  //     }, 300),
  //   []
  // );

  const columnsGasDeliveryPlan = [
    {
      dataField: "PLAN_MONTH",
      text: "Month",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7e8eda",
        fontSize: "12px",
        width: "2%",
      },
    },
    {
      dataField: "PLAN_EAST",
      text: "Gas Delivery Plan East",
      headerAlign: "center",
      editable: true,
      align: "center",
      formatter: formatNumber,
      headerStyle: {
        backgroundColor: "#6478D7",
        width: "5%",
        fontSize: "12px",
      },
      style: {
        cursor: "pointer"
      },
      editorStyle: () => {
        return { height: "25px" }
      },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "PLAN_WEST",
      text: "Gas Delivery Plan West",
      headerAlign: "center",
      editable: true,
      align: "center",
      formatter: formatNumber,
      headerStyle: {
        backgroundColor: "#6478D7",
        width: "5%",
        fontSize: "12px",
      },
      style: {
        cursor: "pointer"
      },
      editorStyle: () => {
        return { height: "25px" }
      },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "PLAN_TOTAL",
      text: "Gas Delivery Plan Total",
      headerAlign: "center",
      editable: true,
      align: "center",
      formatter: formatNumber,
      headerStyle: {
        backgroundColor: "#6478D7",
        width: "5%",
        fontSize: "12px",
      },
      style: {
        cursor: "pointer"
      },
      editorStyle: () => {
        return { height: "25px" }
      },
      validator: (newValue, row, column, done) => {
        setTimeout(() => {
          if (isNaN(newValue)) {
            return done({
              valid: false,
              message: "Should be numeric",
            });
          }
          return done();
        }, 0);
        return {
          async: true,
        };
      },
    },
    {
      dataField: "df1",
      text: "Remark ( Average Gas Delivery Report )",
      headerAlign: "center",
      isDummyField: true,
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#6478D7",
        fontSize: "12px",
        width: "10%",
      },
      sort: false,
      formatter: InputRemark,
    },
    
  ];


  return (
    <div>
      
      {/* <div className="d-flex justify-content-end mt-2 mb-2"> */}
      <FormGroup className="row mb-3 mt-2">
            <Col
              sm={1}
              className="d-flex align-items-center justify-content-end"
            >
              <h5 style={{whiteSpace:"nowrap"}}> Data Year :</h5>
            </Col>
            <Col sm={3} className="align-items-center justify-content-start">
              <Select
                placeholder="Select Year"
                value={yearSelected}
                onChange={handleSelectedYear}
                options={listYear}
                classNamePrefix="select2-selection"
              />
            </Col>
        
          <Col
              sm={8}
              className=" d-flex align-items-center justify-content-end"
            >
        {permission.eOTH && (
          <button
            type="button"
            className="btn btn-success me-2"
            onClick={handleSaveData}
          >
            <i className="bx bx-save"></i>&nbsp; Save
          </button>
        )}
          </Col>
            </FormGroup>
      {/* </div> */}
      <div className="row">
        <Col sm="12">
          <div>
            <BootstrapTable
              id="gas-delivery-tab-table"
              keyField="month"
              wrapperClasses="table-on-scroll"
              data={listDataGasDeliveryPlan}
              columns={columnsGasDeliveryPlan}
              headerClasses="header-style"
              rowStyle={rowStyleFontWhite}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                onStartEdit: (oldValue, newValue, row, column) => {
                  $("#gas-delivery-tab-table .form-control.editor.edit-text").bind(
                    "enterKey",
                    function (e) {
                      let cell = $(this).parent().next();
                      setTimeout(() => {
                        cell.click();
                      }, 50);
                    }
                  );
                  $(
                    "#gas-delivery-tab-table .form-control.editor.edit-text"
                  ).keypress(function (e) {
                    if (e.keyCode == 13) {
                      $(this).trigger("enterKey");
                    }
                  });
                },
              })}
            />
          </div>
        </Col>
      </div>
      {/* <div className="row">
        <Col sm="6">
          <div>
            <BootstrapTable
              id="loss-major-tab-table"
              keyField="month"
              wrapperClasses="table-on-scroll"
              data={listDataLossMajor}
              rowStyle={rowStyleFontWhite}
              columns={columnsGasLossMajor}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            />
          </div>
        </Col>
        <Col sm="6">
          <div>
            <BootstrapTable
              id="loss-minor-tab-table"
              keyField="month"
              wrapperClasses="table-on-scroll"
              data={listDataLossMinor}
              rowStyle={rowStyleFontWhite}
              columns={columnsGasLossMinor}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            />
          </div>
        </Col>
      </div> */}
    </div>
  );
}
export const gasDeliveryPlanModel = {
  PID: "",
  PLAN_DATE: "",
  PLAN_MONTH: 0,
  PLAN_EAST: 0,
  PLAN_WEST: 0,
  PLAN_TOTAL: 0,
  PLAN_REMARK: "",
};

const columnsGasLossMajor = [
  {
    dataField: "MAJORLOSS_MONTH",
    text: "Month",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#7e8eda",
      width: "20%",
      fontSize: "12px",
    },
  },
  {
    dataField: "MAJORLOSS_DATAGAS",
    text: "Gas Control",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
  {
    dataField: "MAJORLOSS_DATATSO",
    text: "TSO",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
];
const lossMajorModel = {
  PID: "",
  MAJORLOSS_DATE: "",
  MAJORLOSS_MONTH: 0,
  MAJORLOSS_DATAGAS: 0,
  MAJORLOSS_DATATSO: 0,
  // MAJORLOSS_DATA: 0,
};

const columnsGasLossMinor = [
  {
    dataField: "MINORLOSS_MONTH",
    text: "Month",
    headerAlign: "center",
    editable: false,
    align: "center",
    headerStyle: {
      backgroundColor: "#7e8eda",
      width: "20%",
      fontSize: "12px",
    },
  },
  {
    dataField: "MINORLOSS_DATAGAS",
    text: "Gas Control",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
  {
    dataField: "MINORLOSS_DATATSO",
    text: "TSO",
    headerAlign: "center",
    editable: true,
    align: "center",
    formatter: formatNumber,
    headerStyle: {
      backgroundColor: "#6478D7",
      width: "20%",
      fontSize: "12px",
    },
    style: {
      cursor: "pointer"
    },
    editorStyle: () => {
      return { height: "25px" }
    },
    validator: (newValue, row, column, done) => {
      setTimeout(() => {
        if (isNaN(newValue)) {
          return done({
            valid: false,
            message: "Should be numeric",
          });
        }
        return done();
      }, 0);
      return {
        async: true,
      };
    },
  },
];
const lossMinorModel = {
  PID: "",
  MINORLOSS_DATE: "",
  MINORLOSS_MONTH: 0,
  MINORLOSS_DATAGAS: 0,
  MINORLOSS_DATATSO: 0,
  // MINORLOSS_DATA: 0,
};

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn

GasDelivery.propTypes = {
  yearSelected: PropTypes.any,
};
